import demoService from '../../services/demo';

// import * as rootypes from '../../store/mutations_type';

const types = {
  INITLIST: 'list/initList',
};

const state = {
  list: [],
};

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
  initList: s => s.list,
};

const actions = {
  actionInitList({ commit }) {

    demoService
    .demo()
    .then((res) => {
      commit(types.INITLIST, res);
    })
    .catch(() => {
      // commit(rootypes.isShowRootLoading);
    });
    
  },
};

// mutations
const mutations = {
  [types.INITLIST](s, r) {
    s.list = r;
  },
};

/*
  因為我們把 vuex 所有職權都寫在同一隻檔案，
  所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/list.js